<template>
  <v-layout>
    <v-flex xs12 sm6 offset-sm3>
      <div v-for="n in news" :key="n.id">
        <v-card>
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">{{ n.title }}</h3>
              <div>{{ new Date(n.publishDate).toLocaleDateString() }}</div>
            </div>
          </v-card-title>
          <v-card-text v-html="n.text"></v-card-text>
        </v-card>
        <v-divider></v-divider>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import api from "../api";

export default {
  data() {
    return {
      news: [],
      error: ""
    };
  },
  async created() {
    try {
      this.error = null;
      this.news = await api.getPublishedNews();
    } catch (error) {
      this.error = error.response.data;
    }
  }
};
</script>

<style>
</style>
